module.exports = "/_next/static/images/WhatIsCyberInsuranceBgWavesLeft-cc3ffbdc14fc95fc7bd23c3cb0470ea8.svg";